import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Checkbox,
  CircularProgress,
  Table,
  TableBody,
  TableCell as MuiTableCell,
  TableRow,
  Typography
} from "@material-ui/core";
import styled from "styled-components";
import RoundedAvatar from "../../../waybee-ui/RoundedAvatar";
import StudentInfoPopover from "../../../components/StudentInfoPopover";

const TableCell = styled(MuiTableCell)`
  border-bottom: none;
  padding-top: 10px;
  padding-bottom: 10px;
`;

const CheckboxCell = styled(TableCell)`
  width: 52px;
  padding: 8px;
`;

const ClickableRow = styled(TableRow)`
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};

  &:hover {
    background-color: ${({ $disabled }) =>
      $disabled ? "transparent" : "rgba(0, 0, 0, 0.04)"};
  }
`;

const UserInfo = styled(Box)`
  margin-left: 12px;
  min-width: 0;
`;

const TextName = styled(Typography)`
  :hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

const ReceiversSelector = ({
  users,
  disabled,
  isLoading,
  onToggleUser,
  isResend,
  showStudentLabel
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [popoverUserId, setPopoverUserId] = useState(null);

  const popoverOpen = (event, id) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setPopoverUserId(id);
  };

  const popoverClose = () => {
    setAnchorEl(null);
    setPopoverUserId(null);
  };

  if (isLoading) {
    return (
      <Box p={4} textAlign="center">
        <CircularProgress />
      </Box>
    );
  }

  if (users && users.length === 0) {
    return (
      <Box my={4} mx={2}>
        <Typography variant="body1" align="center">
          Nenhum destinatário encontrado.
        </Typography>
      </Box>
    );
  }
  return (
    <Table aria-label="simple table">
      <TableBody>
        {users.map(student => {
          return (
            <ClickableRow
              key={student.id}
              $disabled={disabled || isResend}
              onClick={() => {
                if (!disabled && !isResend) {
                  onToggleUser(student.id, !student.checked);
                }
              }}
            >
              <TableCell className="student">
                <Box display="flex" alignItems="center">
                  <RoundedAvatar
                    imageSrc={student.photoProfile}
                    icon="person"
                    size={40}
                  />
                  <UserInfo>
                    <TextName
                      variant="body2"
                      onClick={e => {
                        popoverOpen(e, student.id);
                      }}
                    >
                      {student.name}
                    </TextName>
                    <Typography variant="body2" color="textSecondary">
                      {showStudentLabel && "Aluno · "}
                      RA:
                      {" "}
                      {student.studentId}
                    </Typography>
                  </UserInfo>
                </Box>
              </TableCell>
              {!isResend && (
                <CheckboxCell align="center">
                  <Checkbox
                    checked={student.checked}
                    color="primary"
                    disableRipple
                    id={student.id}
                    name={student.id}
                    onClick={e => e.stopPropagation()}
                    onChange={event =>
                      onToggleUser(student.id, event.target.checked)
                    }
                    disabled={disabled}
                  />
                </CheckboxCell>
              )}
            </ClickableRow>
          );
        })}
        {popoverUserId && (
          <StudentInfoPopover
            anchorEl={anchorEl}
            onClose={popoverClose}
            userId={popoverUserId}
          />
        )}
      </TableBody>
    </Table>
  );
};

ReceiversSelector.propTypes = {
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: "",
      photoProfile: "",
      name: "",
      checked: ""
    })
  ).isRequired,
  onToggleUser: PropTypes.func,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isResend: PropTypes.bool,
  showStudentLabel: PropTypes.bool
};

ReceiversSelector.defaultProps = {
  disabled: false,
  isLoading: false,
  onToggleUser: () => {},
  isResend: false,
  showStudentLabel: false
};

export default ReceiversSelector;
